/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, budget: NonNullable<unknown>, quota: NonNullable<unknown> }} Sub_Quotas_Over_Budget_Warn_ManyInputs */



/**
* | output |
* | --- |
* | "{count} limits are above your organisation's total budget of {budget}, the highest {quota} — those users still stop at {budget}." |
*
* @param {Sub_Quotas_Over_Budget_Warn_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_warn_many = /** @type {((inputs: Sub_Quotas_Over_Budget_Warn_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_Warn_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Limits liegen über dem Gesamtbudget Ihrer Organisation von ${i?.budget}, das höchste ${i?.quota} – diese Nutzer werden weiterhin bei ${i?.budget} gestoppt.`)
	return /** @type {LocalizedString} */ (`${i?.count} limits are above your organisation's total budget of ${i?.budget}, the highest ${i?.quota} — those users still stop at ${i?.budget}.`)
});